import { useState } from "react";
import Button from "../UI/Button";
import firebase from "../../firebase/config";
import { useDispatch } from "react-redux";
import { confirmChangePassword, confirmForgotPasswordAndSave, sendOtpForChangePassword, sendOtpForForgotPassword } from "../../redux/createMessage/slice";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
    const [adminDetails, setAdminDetails] = useState({ newPassword: "", otpForForgotPassword: "", email : ""});
    const [success, setSuccess] = useState(""); // to display message if the message is sent or not
    const [error, setError] = useState("");
    const [showOtpField, setShowOtpField] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false); // New state for password visibility

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getUpdatedDetails = (e: any) => {
        setAdminDetails((prevMessages) => ({
        ...prevMessages,
        [e.target.name]: e.target.value,
      }));
    };

    const sendForgotPasswordOtp = async (e: any) => {
      console.log("sendResetPasswordLink clicked")

        e.preventDefault();
        const adminSnapshot = await firebase.firestore().collection("admin").doc("adminCredentials").get();
        const adminData = adminSnapshot.data();
        const {email} = e.target

        if(adminData && adminData.email === email.value){
          console.log("correct credentials")
            setSuccess(`OTP for reset password has been sent to the provided email address.`)
            setError("")
            setShowOtpField(true)
            dispatch(sendOtpForForgotPassword())
        }else{
            console.log("wrong credentials")
            setError("Please re-check the credentials")
            setSuccess("")
        }
    }

        const confirmOtpAndSavePassword = async ()=>{
            const adminSnapshot = await firebase.firestore().collection("admin").doc("adminCredentials").get();
            const adminData = adminSnapshot.data();

            let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,}$/;
            if (!passwordRegex.test(adminDetails.newPassword)) {
              setError("Password must contain at least one uppercase letter, one number, one special character and minimum of 8 length.");
              setSuccess("")
              return;
            }
            if(adminData && adminData.email === adminDetails.email && adminData.otpForForgotPassword === Number(adminDetails.otpForForgotPassword)){
              dispatch(confirmForgotPasswordAndSave(adminDetails)) ;
              setSuccess("New password set successfully")
              setError("")
              setTimeout(() => {
                navigate("/", {});
              },2000)
            }else{
              setError("Please re-check, Something went wrong")
              setSuccess("")
            }
          }


  return (
    <main>
      <div className="container-fluid px-4">
        <div>
          <h1>Forgot Password</h1>
        </div>
        <div className="row">
          <div className="col-md-12">
            <form 
            onSubmit={sendForgotPasswordOtp}
            >
              <div className="form-row">
              Enter Your Email Address:<input
                  type="text"
                  placeholder="Enter Your Email Address"
                  className="form-control"
                  style={{color:"black"}}
                  id=""
                  name="email"
                  onChange={getUpdatedDetails}
                />
              </div>
              {showOtpField &&   <div>
                                    <div className="form-row">
                                    Enter OTP:<input
                                        type="number"
                                        placeholder="Enter OTP"
                                        className="form-control"
                                        style={{color:"black"}}
                                        id=""
                                        name="otpForForgotPassword"
                                        onChange={getUpdatedDetails}
                                        />
                                    </div>
                                    <div className="form-row">
                                        Enter New Password:
                                        <div className="d-flex">
                                        <input
                                          type={showNewPassword ? "text" : "password"}
                                          placeholder="Enter New Password"
                                          className="form-control"
                                          style={{color:"black"}}
                                          id=""
                                          name="newPassword"
                                          onChange={getUpdatedDetails}
                                          />
                                           <button
                                              className="btn rounded-0 rounded-end"
                                              type="button"
                                              onClick={() => {
                                                setShowNewPassword(!showNewPassword); // Toggle the password visibility
                                              }}>
                                              {showNewPassword ? "Hide" : "Show"}
                                            </button>
                                        </div>
                                        
                                    </div>
                                </div>
                }
              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}
              {showOtpField ? <Button type = "button" text= "Confirm" className="btn btn-primary btn-lg mx-2" onClick={confirmOtpAndSavePassword} /> : null}
              <Button type = "submit" text={showOtpField ? "Resend OTP" : "Send OTP"} className="btn btn-primary btn-lg"/>
            </form>
          </div>
        </div>
        </div>    
    </main>
  );
}